import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SingleSelectButton from './single-select-button';

import './index.css';

export default class SingleSelect extends Component {
  static propTypes = {
    selectOptions: PropTypes.array.isRequired,
    onSelect: PropTypes.func,
    value: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = { activeOption: props.value };
    this.handleSelectOption = this.handleSelectOption.bind(this);
  }

  handleSelectOption(id) {
    const selectedOption = this.state.activeOption === id ? null : id;
    this.setState({ activeOption: selectedOption });
    this.props.onSelect(selectedOption);
  }

  renderSelectOptions() {
    const passedOptions = this.props.selectOptions;
    const selectOptions = passedOptions.map((selectOption, index) => {
      return (
        <SingleSelectButton
          id={ index }
          key={ selectOption.optionText }
          optionText={ selectOption.optionText }
          subtext={ selectOption.subtext }
          handleSelectOption={ this.handleSelectOption }
          activeOption={ this.state.activeOption }
        />
      );
    });

    return selectOptions;
  }

  render() {
    return (
      <div className="select-options">
        { this.renderSelectOptions() }
      </div>
    );
  }
}
